import React from 'react';
import { Drawer, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';

interface BlogGalleryProps {
    viewGallery: boolean;
    viewGalleryHandler: () => void;
    gallery: Array<string>;
}

export const BlogGallery: React.FC<BlogGalleryProps> = React.memo(
    ({ viewGallery, viewGalleryHandler, gallery }) => {
        return (
            <Drawer open={viewGallery} onClose={viewGalleryHandler} anchor='left'>
                <div className='blog__gallery'>
                    <IconButton
                        onClick={viewGalleryHandler}
                        className='blog__gallery__close'
                    >
                        <Close />
                    </IconButton>
                    {gallery.map(image => (
                        <img
                            key={image}
                            src={image}
                            alt={image}
                            className='blog__gallery__image'
                        />
                    ))}
                </div>
            </Drawer>
        );
    }
);
